import { render, staticRenderFns } from "./groupManagement.vue?vue&type=template&id=034de976&"
import script from "./groupManagement.vue?vue&type=script&lang=js&"
export * from "./groupManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports